<template>
  <table class="table table-sm table-borderless m-0 table-unstriped">
    <tbody>
      <tr v-for="(row, rowIndex) in groups" :key="rowIndex">
        <td v-for="(permission, permissionIndex) in row" :key="permissionIndex">
          <icon :name="permissionCheckIcon(permission)" size="11"></icon>
          <small>{{permission.name}}</small>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import Icon from '@/components/Icon'

export default {
  name: 'TeamTabs',
  props: ['availablePermissions', 'permissions', 'columns'],
  components: { Icon },
  computed: {
    groups () {
      var lists = []
      for (var i = 0; i < this.availablePermissions.length; i++) {
        if (i % this.columns === 0) {
          lists.push([this.availablePermissions[i]])
        } else {
          lists[lists.length - 1].push(this.availablePermissions[i])
        }
      }
      return lists
    }
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    permissionCheckIcon (permission) {
      if (this.permissions.indexOf(permission.id) === -1) {
        return 'cross'
      } else {
        return 'check'
      }
    }
  }
}
</script>
<style scoped>
.table-unstriped {
  background-color: transparent;
}
.table-unstriped tbody tr {
  background-color: transparent;
}
.table-unstriped tbody tr td {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/manage/PermissionList.vue